import { useMemo, useState } from "react";
import { useApp } from "../app/AppContext";
import { todayKey } from "../lib/date";
import { JOT_SORTS, type JotSort, readJotSort, sortJots, writeJotSort } from "../lib/jots";
import { AiRewrite } from "./AiRewrite";
import { JotRow } from "./JotRow";
import { JotsHistoryModal } from "./JotsHistoryModal";

export function JotsWidget() {
  const app = useApp();
  const today = todayKey();
  const [text, setText] = useState("");
  const [sort, setSort] = useState<JotSort>(readJotSort);
  const [historyOpen, setHistoryOpen] = useState(false);

  const jots = useMemo(
    () => sortJots(app.notes.filter((n) => n.dayDate === today), sort),
    [app.notes, today, sort],
  );

  function add() {
    const t = text.trim();
    if (!t) return;
    app.createNote({ dayDate: today, title: t });
    setText("");
  }

  return (
    <div className="jots">
      <div className="jots-head">
        <span className="jots-title">
          <span className="jots-ico">▪</span> Today's Jots
          <span className="jots-count">{jots.length}</span>
        </span>
        <div className="jots-tools">
          <select
            className="jots-sort"
            value={sort}
            onChange={(e) => {
              const v = e.target.value as JotSort;
              setSort(v);
              writeJotSort(v);
            }}
            aria-label="Sort jots"
            title="Sort jots"
          >
            {JOT_SORTS.map((s) => (
              <option key={s.key} value={s.key}>
                {s.label}
              </option>
            ))}
          </select>
          <button className="jots-hist-btn" onClick={() => setHistoryOpen(true)} title="History">
            ↺
          </button>
        </div>
      </div>

      <form
        className="jots-add"
        onSubmit={(e) => {
          e.preventDefault();
          add();
        }}
      >
        <span className="plus">+</span>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Jot for today…"
          aria-label="Add a jot"
        />
        <AiRewrite text={text} onAccept={setText} compact />
      </form>

      <div className="jots-list">
        {jots.length === 0 && <div className="jots-empty">Nothing yet — jot your first thought.</div>}
        {jots.map((j) => (
          <JotRow key={j.id} jot={j} />
        ))}
      </div>

      <button className="jots-hist-link" onClick={() => setHistoryOpen(true)}>
        ↺ History
      </button>

      {historyOpen && <JotsHistoryModal onClose={() => setHistoryOpen(false)} />}
    </div>
  );
}
